import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Users, Sliders, IndianRupee, BarChart3, ArrowRight } from "lucide-react";

export default function SuperAdminHome() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [tenants, features, plans, rev] = await Promise.all([
          api.get("/superadmin/tenants"),
          api.get("/superadmin/features"),
          api.get("/superadmin/plans"),
          api.get("/superadmin/analytics/revenue"),
        ]);
        setStats({
          tenants: tenants.data.length,
          features: features.data.length,
          plans: plans.data.length,
          revenue: rev.data.overall.total_paid,
        });
      } catch { /* noop */ }
    })();
  }, []);

  const tiles = [
    { to: "/superadmin/tenants", icon: Users, label: "Tenants", value: stats?.tenants },
    { to: "/superadmin/features", icon: Sliders, label: "Features", value: stats?.features },
    { to: "/superadmin/plans", icon: IndianRupee, label: "Plans", value: stats?.plans },
    { to: "/superadmin/analytics", icon: BarChart3, label: "Paid revenue", value: stats ? `₹${stats.revenue.toLocaleString()}` : null },
  ];

  return (
    <div className="space-y-6" data-testid="super-home-page">
      <div>
        <h1 className="font-display text-3xl">Super Admin Console</h1>
        <p className="text-sm text-[hsl(var(--kb-muted))] mt-1">Platform-wide billing, tenants, and feature catalog.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to} className="bg-white border border-[hsl(var(--kb-border))] p-5 hover:border-[hsl(var(--kb-primary))]/40 transition" data-testid={`super-home-${t.label.toLowerCase()}`}>
            <div className="flex items-center gap-2 text-xs uppercase tracking-wide text-[hsl(var(--kb-muted))]"><t.icon size={14} />{t.label}</div>
            <div className="flex items-baseline justify-between mt-2">
              <div className="font-display text-3xl">{t.value ?? "—"}</div>
              <ArrowRight size={16} className="text-[hsl(var(--kb-muted))]" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
